export default "__VITE_ASSET__CQso_4Cw__"